export const BOOLEANSET = {
  TRUE: true,
};
